import { useLocation } from "react-router-dom";
import EventLocation from "./EventLocation";
import GolfEventLocation from "../GolfEvent/GolfEventLocation";

export default function EventPage() {
  const location = useLocation();
  const locationData = location.state?.currentLocation;
  const eventType = locationData?.eventType;

  if (eventType === "golf") {
    return <GolfEventLocation />;
  }

  // Default: existing multi-floor event view (F1 Vegas style)
  return <EventLocation />;
}